import React from 'react';
import AsignarCursosAreaCatalog from './AsignarCursosAreaCatalog';

export default function AsignarCursosAreaPage() {
    return (
        <div className="lms-page-container">
            <AsignarCursosAreaCatalog />
        </div>
    );
}
